import { GESTION_ROUTES } from "constants/gestion-routes";

export const FINANCIAL_ACCOUNT_TYPE_PARAM = "accountType";
export const FINANCIAL_ACCOUNT_ID_PARAM = "account";

const TEAM_TARGET = /^team:(\d+)$/;
const ROSTER_MEMBER_TARGET = /^roster-member:(\d+)$/;

export const teamSiloTargetId = (teamId) => (teamId == null || teamId === "" ? null : `team:${teamId}`);

export const teamFinancialAccountHref = (customerId, teamId) => {
  if (!customerId || teamId == null || teamId === "") return null;
  return GESTION_ROUTES.teamFinancials(customerId, teamId);
};

export const financialAccountHref = (customerId, account) => {
  if (!customerId || !account?.target_id) return null;
  const targetId = String(account.target_id);
  if (account.type === "entity") {
    const team = targetId.match(TEAM_TARGET);
    if (team) return GESTION_ROUTES.teamFinancials(customerId, team[1]);
    return GESTION_ROUTES.entityFinancials(customerId, targetId);
  }
  const member = targetId.match(ROSTER_MEMBER_TARGET);
  if (member) return GESTION_ROUTES.playerFinancials(customerId, member[1]);
  if (!account.external_entity_id) return null;
  return GESTION_ROUTES.individualFinancials(customerId, account.external_entity_id, targetId);
};

export const financialAccountHrefFromSearch = (customerId, search) => {
  const params = new URLSearchParams(search || "");
  const type = params.get(FINANCIAL_ACCOUNT_TYPE_PARAM);
  const targetId = params.get(FINANCIAL_ACCOUNT_ID_PARAM);
  if (!type || !targetId) return null;
  if (type === "entity") return financialAccountHref(customerId, { type, target_id: targetId });
  const member = targetId.match(ROSTER_MEMBER_TARGET);
  return member ? GESTION_ROUTES.playerFinancials(customerId, member[1]) : null;
};
